export function normalData(obj) {
    if (typeof obj !== 'object' || obj === null) {
        return obj;
    }

    if (obj instanceof Date) {
        return new Date(obj.getTime());
    }

    if (obj instanceof Array) {
        return obj.reduce((arr, item, index) => {
            arr[index] = normalData(item);
            return arr;
        }, []);
    }

    if (obj instanceof Object) {
        return Object.keys(obj).reduce((newObj, key) => {
            newObj[key] = normalData(obj[key]);
            return newObj;
        }, {});
    }
}

export const normalSelectValue = (_itemSelect) => {
    if (_itemSelect instanceof Object) {
        return _itemSelect?.value ?? null;
    }

    if (typeof _itemSelect === 'string') {
        const match = _itemSelect.match(/^\w+\((\d+),?.*\)$/);
        if (match) {
            return Number(match[1]);
        }
    }

    return _itemSelect && _itemSelect !== false ? _itemSelect : null;
};

/**
 * Hàm mã hóa giá trị của checkbox group thành một số nguyên để lưu vào database.
 * Cách mã hóa là sử dụng bitwise operation, với mỗi option tương ứng với một bit trong số nguyên.
 * Nếu option được chọn, bit tương ứng sẽ được đặt thành 1, ngược lại là 0.
 */
export const encodeCheckboxGroup = (selectedValues, options) => {
    if (!Array.isArray(selectedValues) || !Array.isArray(options)) return 0;

    return options.reduce((result, opt, index) => {
        if (selectedValues.includes(opt.value)) {
            result |= 1 << index; // set bit tại vị trí index
        }
        return result;
    }, 0);
};
